import classNames from 'classnames';
import styles from './ArticleHeader.module.scss';
import { Heading, Grid, Link, Picture } from 'ui/components';

export interface ArticleHeaderProps {
    className?: string;
    kicker?: string;
    teaser?: string;
    showAnchorLink?: boolean;
    anchorLinkText?: string;
    heading?: React.ReactNode;
    thumbnailPicture?: Content.Image;
    thumbnailToggle?: boolean;
}

export const ArticleHeader: React.FC<ArticleHeaderProps> = ({
    className,
    teaser,
    heading,
    anchorLinkText,
    showAnchorLink,
    thumbnailPicture,
    thumbnailToggle
}) => {
    return (
        <header
        aria-label={'Overskrift: ' + heading}
        className={classNames(styles.ArticleHeader, className)}>
            <Grid full wrap>
                <div className={styles.ArticleHeader_heading}>
                    <Heading headingLevel="h1" style="xl">
                        {heading}
                    </Heading>
                </div>
                {showAnchorLink && (
                    <Link ariaLabel={anchorLinkText} url="#contactBox" hasArrow={true} className={classNames(styles.ArticleHeader_contactAnchorLink, 'u-hidden-in-print')}>
                        {anchorLinkText}
                    </Link>
                )}
                <div className={classNames(styles.ArticleHeader_lead, "ArticleHeaderLead")} dangerouslySetInnerHTML={{ __html: teaser.replace(/(?:\r\n|\r|\n)/g, '<br>') }}></div>
				{thumbnailPicture?.url && (
					<div className={styles.ArticleHeader_thumbnail}>
						<Picture
							url={thumbnailPicture.url}
							properties={thumbnailPicture.properties}
							isCover={true}
							lazyload={false}
							removeAlt={thumbnailToggle}
						/>
					</div>
				)}
            </Grid>
        </header>
    );
};
